import { MILEAGE_UNIT } from '../types';
import getConfig from 'next/config';

export const years: string[] = [
  '2001',
  '2002',
  '2003',
  '2004',
  '2005',
  '2006',
  '2007',
  '2008',
  '2009',
  '2010',
  '2011',
  '2012',
  '2013',
  '2014',
  '2015',
  '2016',
  '2017',
  '2018',
  '2019',
  '2020',
  '2021',
];

export const locations = [
  { displayName: 'All Ireland', value: 'All Ireland' },
  { displayName: 'Dublin', value: 'Dublin' },
  { displayName: 'Leinster', value: 'Leinster' },
  { displayName: 'Munster', value: 'Munster' },
  { displayName: 'Ulster', value: 'Ulster' },
  { displayName: 'Connacht', value: 'Connacht' },
  { displayName: 'Antrim', value: 'Antrim' },
  { displayName: 'Armagh', value: 'Armagh' },
  { displayName: 'Carlow', value: 'Carlow' },
  { displayName: 'Cavan', value: 'Cavan' },
  { displayName: 'Clare', value: 'Clare' },
  { displayName: 'Cork', value: 'Cork' },
  { displayName: 'Derry', value: 'Derry' },
  { displayName: 'Donegal', value: 'Donegal' },
  { displayName: 'Down', value: 'Down' },
  { displayName: 'Dublin', value: 'Dublin' },
  { displayName: 'Fermanagh', value: 'Fermanagh' },
  { displayName: 'Galway', value: 'Galway' },
  { displayName: 'Kerry', value: 'Kerry' },
  { displayName: 'Kildare', value: 'Kildare' },
  { displayName: 'Kilkenny', value: 'Kilkenny' },
  { displayName: 'Laois', value: 'Laois' },
  { displayName: 'Leitrim', value: 'Leitrim' },
  { displayName: 'Limerick', value: 'Limerick' },
  { displayName: 'Longford', value: 'Longford' },
  { displayName: 'Louth', value: 'Louth' },
  { displayName: 'Mayo', value: 'Mayo' },
  { displayName: 'Meath', value: 'Meath' },
  { displayName: 'Monaghan', value: 'Monaghan' },
  { displayName: 'Offaly', value: 'Offaly' },
  { displayName: 'Roscommon', value: 'Roscommon' },
  { displayName: 'Sligo', value: 'Sligo' },
  { displayName: 'Tipperary', value: 'Tipperary' },
  { displayName: 'Tyrone', value: 'Tyrone' },
  { displayName: 'Waterford', value: 'Waterford' },
  { displayName: 'Westmeath', value: 'Westmeath' },
  { displayName: 'Wexford', value: 'Wexford' },
  { displayName: 'Wicklow', value: 'Wicklow' },
];

export type CountiesList = { displayName: string; value: string };

export const counties: CountiesList[] = [
  { displayName: 'Co. Dublin', value: 'Dublin' },
  { displayName: 'Co. Antrim', value: 'Antrim' },
  { displayName: 'Co. Armagh', value: 'Armagh' },
  { displayName: 'Co. Carlow', value: 'Carlow' },
  { displayName: 'Co. Cavan', value: 'Cavan' },
  { displayName: 'Co. Clare', value: 'Clare' },
  { displayName: 'Co. Cork', value: 'Cork' },
  { displayName: 'Co. Derry', value: 'Derry' },
  { displayName: 'Co. Donegal', value: 'Donegal' },
  { displayName: 'Co. Down', value: 'Down' },
  { displayName: 'Co. Dublin', value: 'Dublin' },
  { displayName: 'Co. Fermanagh', value: 'Fermanagh' },
  { displayName: 'Co. Galway', value: 'Galway' },
  { displayName: 'Co. Kerry', value: 'Kerry' },
  { displayName: 'Co. Kildare', value: 'Kildare' },
  { displayName: 'Co. Kilkenny', value: 'Kilkenny' },
  { displayName: 'Co. Laois', value: 'Laois' },
  { displayName: 'Co. Leitrim', value: 'Leitrim' },
  { displayName: 'Co. Limerick', value: 'Limerick' },
  { displayName: 'Co. Longford', value: 'Longford' },
  { displayName: 'Co. Louth', value: 'Louth' },
  { displayName: 'Co. Mayo', value: 'Mayo' },
  { displayName: 'Co. Meath', value: 'Meath' },
  { displayName: 'Co. Monaghan', value: 'Monaghan' },
  { displayName: 'Co. Offaly', value: 'Offaly' },
  { displayName: 'Co. Roscommon', value: 'Roscommon' },
  { displayName: 'Co. Sligo', value: 'Sligo' },
  { displayName: 'Co. Tipperary', value: 'Tipperary' },
  { displayName: 'Co. Tyrone', value: 'Tyrone' },
  { displayName: 'Co. Waterford', value: 'Waterford' },
  { displayName: 'Co. Westmeath', value: 'Westmeath' },
  { displayName: 'Co. Wexford', value: 'Wexford' },
  { displayName: 'Co. Wicklow', value: 'Wicklow' },
];

export const provinces = ['Leinster', 'Munster', 'Ulster', 'Connact'];

export const adSenseAdDetailsStyleId = '2340466210';
export const adSenseSearchStyleId = '8345744711';
export const dashboardPageSize = 10;

export enum ToastError {
  REGULAR = 'Oops! Something went wrong, please try again later',
}

export enum ToastSuccess {
  REGULAR = 'Updated successfully',
}

const ON_REQUEST_PRICE_SECTIONS = ['tractors', 'plantmachinery', 'beefcattle'];

export const isRequestPriceSection = (subsection: string) =>
  ON_REQUEST_PRICE_SECTIONS.includes(subsection);

export const mileageOptions = [
  { label: 'km', value: MILEAGE_UNIT.KILOMETRES },
  { label: 'miles', value: MILEAGE_UNIT.MILES },
];

export const isMigratedPublishFilterSection = (subsection: string) => {
  const {
    publicRuntimeConfig: { MIGRATED_PUBLISH_FILTER_SECTIONS },
  } = getConfig();
  return MIGRATED_PUBLISH_FILTER_SECTIONS.includes(subsection);
};

/** Cookie constants */
export const COOKIE = {
  DD_LEGACY_RECOMMENDED_USER: 'ddRecommendedUser',
  // An identifier for any user (logged in/out)
  DD_CLIENT_ID: 'ddClientId',
  // An identifier for a logged in user
  DD_CLIENT_UID: 'ddClientUid',
} as const;

/** Cookies can have a maximum max-age of 400 days in chrome */
export const MAXIMUM_COOKIE_AGE = 60 * 60 * 24 * 365;

/** Can be set as the 'Expires ' value to expire a cookie */
export const EXPIRE_COOKIE = 'Thu, 01 Jan 1970 00:00:00 GMT';

export const NEXT_AUTH_REFRESH_ACCESS_TOKEN_ERROR_MESSAGE =
  'RefreshAccessTokenError';

export const USER_PROFILE_DATA_TTL_IN_SECONDS = 24 * 60 * 60; // 24 hours;
